import * as React from "react";
import CustomScrollbars from "./CustomScrollbar";
import SingleResponseChart from "./singleResponseChart.Component";
import Loader from "react-loader";
import ModalVideo from "react-modal-video";
import { CSSTransition } from "react-transition-group";
import "./resultTiles.css";

// interface IProps {
//   responseData: any;
// }

class ResponsesTile extends React.Component {
  state = {
    groups: [],
    currentGroup: 0,
    responseData: this.props.responseData,
    videowatched: false,
    isVidModalOpen: false,
    vidLink: " ",
    scrolltop: 0,
  };
  constructor(props) {
    super(props);
    this.generateGroups = this.generateGroups.bind(this);
    this.nextgroup = this.nextgroup.bind(this);
    this.prevgroup = this.prevgroup.bind(this);
    this.radialCharts = this.radialCharts.bind(this);
    this.renderResponseNav = this.renderResponseNav.bind(this);
    this.watchVideo = this.watchVideo.bind(this);
    // video modal fns
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.openVideoModal = this.openVideoModal.bind(this);
    this.closeVideoModal = this.closeVideoModal.bind(this);
    this.scrollContent = this.scrollContent.bind(this);
    this.scrollContentUp = this.scrollContentUp.bind(this);
  }

  componentDidMount() {
    // this.generateGroups();
    // // console.log("ResponseData " + typeof(this.props.responseData))
    if (this.state.groups.length < 1) {
      this.generateGroups();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // // console.log('Component updated props');
    if (this.state.groups.length < 1) {
      this.generateGroups();
    }
    // this.generateGroups();
  }

  scrollContent() {
    if (this.state.scrolltop >= this.refs.scrollbars.getScrollHeight()) {
      this.setState({ scrolltop: this.refs.scrollbars.getScrollHeight() });
      this.refs.scrollbars.scrollTop(this.state.scrolltop);
    } else {
      this.setState((prevState) => ({
        scrolltop: prevState.scrolltop + 300,
      }));
      this.refs.scrollbars.scrollTop(this.state.scrolltop);
      // console.log("Scrolltop vals :" + this.state.scrolltop);
    }
  }

  scrollContentUp() {
    if (this.state.scrolltop < 0) {
      this.setState({ scrolltop: 0 });
    } else {
      this.setState((prevState) => ({
        scrolltop: prevState.scrolltop - 300,
      }));
      this.refs.scrollbars.scrollTop(this.state.scrolltop);
    }
  }

  handleOpenModal(event) {
    this.openVideoModal(event.target.value);
  }

  openVideoModal(vidLink) {
    this.setState({ isVidModalOpen: true, videoLink: vidLink });
  }

  closeVideoModal() {
    this.setState({ videoLink: "", isVidModalOpen: false, videowatched: true });
  }

  // generate groups from passed data
  generateGroups() {
    let qgroups = [];

    if (this.props.responseData) {
      const responses = this.props.responseData.responses;

      for (const row of responses) {
        qgroups.push(row.Group);
        // console.log("GROUPS: " + row.Group);
      }

      qgroups = Array.from(new Set(qgroups));

      this.setState({ groups: qgroups });
    } else {
      // console.error("ReceivedData " + typeof this.props.responseData)
    }
  }

  // responses nav functions
  renderResponseNav() {
    if (this.state.groups.length > 0) {
      return (
        <div className="response-nav">
          <button
            className="red-button response-nav-btn"
            onClick={this.prevgroup}
          >
            &lt;
          </button>
          <h2 className="response-category">
            {this.state.groups[this.state.currentGroup]}
          </h2>
          <button
            className=" red-button response-nav-btn"
            onClick={this.nextgroup}
          >
            &gt;
          </button>
        </div>
      );
    } else {
      return <p>No data</p>;
    }
  }

  prevgroup() {
    // console.log("Prevgrp clicked")
    let tempIdx = this.state.currentGroup;
    if (tempIdx <= 0) {
      return;
    } else {
      // console.log(this.state.currentGroup)
      tempIdx -= 1;
      this.setState({ currentGroup: tempIdx, scrolltop: 0 }); // video already watched
    }
  }

  nextgroup() {
    // console.log("NExtgrp clicked")
    let tempIdx = this.state.currentGroup;
    // console.log(this.state.currentGroup)
    if (tempIdx >= this.state.groups.length - 1) {
      return;
    } else {
      // console.log(this.state.currentGroup)
      // console.log('next group' + this.state.groups[this.state.currentGroup])
      tempIdx += 1;
      this.setState({
        currentGroup: tempIdx,
        videowatched: false,
        scrolltop: 0,
      });
    }
  }

  watchVideo() {
    this.setState({ videowatched: true });
  }

  radialCharts(currentGroup) {
    if (this.state.groups.length > 0) {
      const groupname = this.state.groups[currentGroup];
      const allresponses = this.props.responseData.responses;

      const responses = this.filterResponseGroup(allresponses, groupname);

      const collapsibles = [];

      const qa = [];

      for (const response of responses) {
        qa.push(
          <SingleResponseChart
            alertLevel={this.geneRateQnlevel(response)}
            answer={response.AnswerValue}
            question={response.Question}
            key={response.Question}
          />
        );
      }

      const colitem = (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="response-content">{qa}</div>
        </CSSTransition>
      );
      collapsibles.push(colitem);

      const groupVideoView = (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="category-video">
            <h1 className="current-groupname response-category">{groupname}</h1>
            <button
              className="blue-button watch-category-vid"
              value="g7Iu7p_0UMc"
              // onClick={this.handleOpenModal}
              onClick={this.watchVideo}
            >
              View Results
            </button>
            {/* <p className="btn-skip-vid" onClick={this.watchVideo}>Skip Video</p> */}
          </div>
        </CSSTransition>
      );

      return (
        <CustomScrollbars
          className="response-disp-area"
          style={{ height: "600px" }}
          ref="scrollbars"
        >
          {/* view video button value = the url/id of the video */}
          {this.state.videowatched ? collapsibles : groupVideoView}
        </CustomScrollbars>
      );
    } else {
      return <Loader />;
    }
  } // end radialcharts

  filterResponseGroup(responses, groupname) {
    const output = [];

    for (const response of responses) {
      if (response.Group === groupname) {
        output.push(response);
      }
    }
    return output;
  } // end filter response grps

  geneRateQnlevel(response) {
    const percent = response.Score / response.MaxPossibleScore;
    // // console.log(percent)
    // // console.log(percent);
    // const rt = [percent, 100] as number[]
    const mn = Math.round(percent * 4);
    const rslt = Math.round(5 - mn);
    return Math.min(5, rslt);
  } // end generateQnLevel

  render() {
    if (
      this.props.responseData !== null ||
      typeof this.props.responseData === "undefined"
    ) {
      return (
        <div className="response-container">
          <ModalVideo
            channel="youtube"
            isOpen={this.state.isVidModalOpen}
            onClose={this.closeVideoModal}
            videoId={this.state.vidLink}
          />

          <p className="dc-responses-title">Responses</p>
          {this.renderResponseNav()}
          <div
            className="scroll-sec"
            style={
              this.state.videowatched
                ? { display: "flex" }
                : { display: "none" }
            }
          >
            <p>Scroll down</p>
            <button
              className="red-button response-nav-btn"
              onClick={this.scrollContent}
            >
              {" "}
              <i
                style={{ color: "#ff0033" }}
                className="fa fa-arrow-down scroll-icon"
                aria-hidden="true"
              />
            </button>
          </div>
          {this.radialCharts(this.state.currentGroup)}
          <div
            className="scroll-sec scroll-sec-up"
            style={
              this.state.videowatched
                ? { display: "flex" }
                : { display: "none" }
            }
          >
            <button
              className="red-button response-nav-btn response-nav-scroll-up"
              onClick={this.scrollContentUp}
            >
              <i
                style={{ color: "#ff0033" }}
                className="fa fa-arrow-down scroll-icon"
                aria-hidden="true"
              />
            </button>
            <p>Scroll Up</p>
          </div>
        </div>
      );
    } else {
      return <Loader />;
    }
  }
}

export default ResponsesTile;



// WEBPACK FOOTER //
// ./src/common/responsesTile.Component.js